import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'base-layout',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TheHeader),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _unref(route).fullPath
        }))
      ])
    ]),
    _createVNode(TheFooter)
  ], 64))
}
}

})